export function LoadingState({ label = "Loading..." }: { label?: string }) {
  return <div>{label}</div>;
}
